import { render, staticRenderFns } from "./EditPricelistItem.vue?vue&type=template&id=91b890b0"
import script from "./EditPricelistItem.vue?vue&type=script&lang=js"
export * from "./EditPricelistItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports